<template>
    <section class="contact-us-section">
        <div class="container">
            <div class="section-title-box">
                <h3 class="section-title">КОНТАКТЫ</h3>
            </div>
            <div class="contacts">
                <div class="contact notViber">
                   <p>Доступный 24/7</p>
                </div>
                <div class="contact">
                    <a rel="nofollow" class="link"><i class="fas fa-map-marker-alt icons"></i>
                        <p>г. {{settings.location}}</p>
                    </a>
                </div>
                <div class="contact">
                    <a rel="nofollow" class="link" :href="'tel:' + settings.phone_number"> 
                        <i class="fas fa-phone icons"></i>
                        <p>{{settings.phone_number_format}}</p>
                       </a>
                </div>
                <div class="contact">
                    <a rel="nofollow" class="link" :href="'tel:' + settings.phone_number"> 
                        <i class="fab fa-telegram-plane"></i>
                        <p>Telegram</p>
                       </a>
                </div>
                <div class="contact">
                    <a rel="nofollow" class="link" :href="settings.whats_app"><i class="fab fa-whatsapp icons"></i>
                    <p>WhatsApp</p>
                    </a>
                </div>
                <div class="contact">
                    <a rel="nofollow" class="link" :href ="'mailto:' + settings.email"><i class="fas fa-envelope icons" ></i>
                        <p>{{settings.email}}</p>
                    </a>
                </div>
            </div>
            <div class="section-title-box">
                <h3 class="section-title">НАПИШИТЕ НАМ</h3>
            </div>
            <div class="contact-text-block">
                <p class="contact-text">
                    Уважаемый клиент, Вашы предложений, сотрудничества и выражения мнение очень важны для нас.  Заполните эту заявку и мы обязательно Вам ответим.
                </p>
            </div>
            <div class="contact-us-section--inner">
                <div class="map-box" id="map">
                    <iframe src="https://yandex.ru/map-widget/v1/?ll=37.628403%2C55.753444&z=12" width="100%" height="480"></iframe>
                </div>
                <div class="contact-us-form-box">
                    <form method="POST" @submit.prevent="submit">
                        <div class="form-group">
                            <label for="name" class="form-label">Имя</label>
                            <input type="text" id="name" name="name" class="form-input contact-input" placeholder="Введите ваше имя" v-model="name"/>
                            <label for="name" style="color: red;" class="form-label" v-if="error">{{error.errors.name}}</label>
                        </div>
                        <div class="form-group">
                            <label for="phone_number" class="form-label">Тел. Номер</label>
                            <input type="number" id="phone_number" name="phone_number" class="form-input contact-input" placeholder="Введите ваше Тел. Номер" v-model="phone_number"/>
                            <label for="phone_number" style="color: red;" class="form-label" v-if="error">{{error.errors.phone_number}}</label>
                        </div>
                        <div class="form-group">
                            <label for="email" class="form-label">Email</label>
                            <input type="text" id="email" name="email" class="form-input" placeholder="Введите ваше Email" v-model="email"/>
                            <label for="email" style="color: red;" class="form-label" v-if="error">{{error.errors.email}}</label>
                        </div>
                        <div class="form-group">
                            <label for="description" class="form-label">Сообщение</label>
                            <textarea name="description" id="description" placeholder="Введите ваше сообщение" rows="10" class="form-textarea" v-model="description"></textarea>
                            <label for="description" style="color: red;" class="form-label" v-if="error">{{error.errors.description}}</label>
                        </div>
                            <button v-if="!msg" type="submit" class=" correctMassige send">Отправлять</button>
                            <p style="font-size: 20px;" class="form-label correctMassige" v-if="msg">{{msg.message}} !!!</p>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import { ref } from 'vue';
    const settings = ref(_configs.settings)
    const name = ref(null)
    const phone_number = ref(null)
    const email = ref(null)
    const description = ref(null)
    const error = ref(null)
    const msg = ref(null)

    async function submit(){
        try{
            error.value = '';
            const {data} = await axios.post('/contact-form/send', {name:name.value, phone_number:phone_number.value, email:email.value, description:description.value });
            msg.value = data;
            name.value = '';
            email.value = '';
            phone_number.value = '';
            description.value = '';
            
        }catch(e){
            error.value = e.response.data;
        }
    }
    
</script>
